var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon color",
    d: "M16.0009 2C12.7528 2.00195 9.60651 3.13321 7.10087 5.2C6.39951 5.76144 5.76231 6.39864 5.20087 7.1C3.13658 9.60659 2.00781 12.7528 2.00781 16C2.00781 19.2472 3.13658 22.3934 5.20087 24.9C5.75655 25.6364 6.39396 26.3073 7.10087 26.9C8.84035 28.3019 10.8901 29.2672 13.0788 29.7152C15.2675 30.1632 17.5317 30.0808 19.6821 29.4751C21.8325 28.8693 23.8067 27.7577 25.4398 26.2332C27.0728 24.7086 28.3173 22.8153 29.0693 20.7116C29.8212 18.6078 30.0588 16.3547 29.7621 14.1404C29.4654 11.9261 28.6431 9.81491 27.3639 7.9833C26.0847 6.15169 24.3857 4.65282 22.4089 3.61192C20.4321 2.57102 18.2349 2.01832 16.0009 2ZM16.0009 7C16.2975 7 16.5876 7.08797 16.8342 7.2528C17.0809 7.41762 17.2732 7.65189 17.3867 7.92597C17.5002 8.20006 17.5299 8.50166 17.472 8.79264C17.4142 9.08361 17.2713 9.35088 17.0615 9.56066C16.8518 9.77044 16.5845 9.9133 16.2935 9.97118C16.0025 10.0291 15.7009 9.99935 15.4268 9.88582C15.1528 9.77229 14.9185 9.58003 14.7537 9.33335C14.5888 9.08668 14.5009 8.79667 14.5009 8.5C14.5061 8.10379 14.6657 7.72526 14.9459 7.44507C15.2261 7.16488 15.6047 7.00518 16.0009 7ZM20.0009 24H12.0009V22H15.0009V16H13.0009V14H17.0009V22H20.0009V24Z",
    fill: "#007A87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.8f157c9ecef3df6ce7cb8dff3d8343de.svg";
export { ForwardRef as ReactComponent };